import { SUPER_ADMIN_API_ENDPOINTS, SUPER_ADMIN_API_URL } from "../../../constants";
import superAdminAxiosInstance from "../../../core/apiService/superAdminApiService";

const fetchRequestLists = async (
  { searchQuery, status, page }: { searchQuery: string; status: string, page:any },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.FETCH_REQUEST_LISTS}?search=${searchQuery}&ApprovalStatus=${status}&page=${page}`
  );
  return response.data;
};


const acceptOrRejectRequest = async ({payload,id}: {payload: any, id: string}, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.put(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.ACCEPT_OR_REJECT}?id=${id}`,
      payload,
    );
    return response.data;
  };


  const fetchONRoles = async (
    {}: any,
    token: string
  ): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.get(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.FETCH_ON_ROLES}?network_type=open`,
    );
    return response.data;
  };

  const fetchONSpecialities = async (
    { roleIDs }: { roleIDs: string },
    token: string
  ): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.get(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.FETCH_ON_SPECIALITIES}?network_role=${roleIDs}`
    );
    return response.data;
  };

  const fetchONMemberShipPlans = async (
    { networkTypeID }: { networkTypeID:string },
    token: string
  ): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.get(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.FETCH_MEMBERSHIP_PLANS}?network_type_id=${networkTypeID}`,
    );
    return response.data;
  };

  const addONUser = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.post(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.ADD_ON_USER}?filter=false`,
      payload,
    );
    return response.data;
  };

  const registerMembership = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.post(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.REGISTER_MEMBERSHIP}?filter=false`,
      payload,
    );
    return response.data;
  };

    const createNetwork = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.post(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.CREATE_NETWORK}`,
      payload,
    );
    return response.data;
  };

  const deleteONUserRequest = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.delete(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.DELETE_ON_USER_REQUEST}`
    );
    return response.data;
  };

  const editONRequest = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.put(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.EDIT_APPROVED_REQUEST}?id=${payload?.user_id}`,
      payload,
    );
    return response.data;
  };

  const fetchONUserDetails = async (userId: string, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.get(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.FETCH_ON_USER_DETAILS}?id=${userId}`,
    );
    return response.data;
  };

  const licenseApproveOrReject = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.put(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.LICENSE_APPROVE_OR_REJECT}?id=${payload?.userId}`,
      payload?.payload,
    );
    return response.data;
  };

  const editLicense = async ({payload,userId}: {payload:any;userId:any}, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.put(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.EDIT_LICENSE}?id=${userId}`,
      payload,
    );
    return response.data;
  };

  const uploadUsers = async (formData: FormData, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    };
    const response = await superAdminAxiosInstance.post(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.REQUEST_LISTS.UPLOAD_USERS}`,
      formData,
      config
    );
    return response.data;
  };

  const superAdminRequestListsService = {
    fetchRequestLists,
    acceptOrRejectRequest,
    fetchONRoles,
    fetchONSpecialities,
    addONUser,
    registerMembership,
    fetchONMemberShipPlans,
    deleteONUserRequest,
    editONRequest,
    fetchONUserDetails,
    licenseApproveOrReject,
    editLicense,
    uploadUsers,
    createNetwork
  };
  
export default superAdminRequestListsService;